// импорт из node_modules ломает тесты, скопировал шрифт сюда
import './fontsource-fira-code/index.css';
// @ts-ignore
import style from './font.module.scss';

export const monospace: string = style.monospace;
